// These pages reserve space for the fixed header through the sync status row.
export const HEADER_SYNC_PATHS = ['/customers', '/products', '/tasks'];
